import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMessages from '../reducer/messages.reducer';

const selectMessagesFeatureUnsafe = createFeatureSelector<fromMessages.MessagesState | undefined>(
  fromMessages.messagesFeatureKey
);

export const selectMessagesFeature = createSelector(
  selectMessagesFeatureUnsafe,
  state => state ?? fromMessages.initialState
);

const { selectEntities, selectAll } = fromMessages.messagesAdapter.getSelectors();

export const selectMessageEntities = createSelector(selectMessagesFeature, selectEntities);

export const selectMessages = createSelector(selectMessagesFeature, selectAll);

export const selectMessageCount = createSelector(selectMessages, results => results.length);

export const selectError = createSelector(selectMessagesFeature, state => state.baseState.error);

/**
 * The message-thread read's failure, deliberately separate from `selectError` so it cannot make the
 * messages list claim it failed. See MessagesState.detailError.
 */
export const selectDetailError = createSelector(selectMessagesFeature, state => state.detailError ?? null);

export const selectIsLoading = createSelector(selectMessagesFeature, state => state.baseState.isLoading);

export const selectPageNumber = createSelector(selectMessagesFeature, state => state.baseState.pageNumber);

export const selectPageSize = createSelector(selectMessagesFeature, state => state.baseState.pageSize);

export const selectIsAtEndOfData = createSelector(selectMessagesFeature, state => state.baseState.isAtEndOfData);

export const selectIsMessageResponsesLoading = createSelector(
  selectMessagesFeature,
  state => state.isMessageResponsesLoading
);

export const selectSelectedMessageId = createSelector(selectMessagesFeature, state => state.selectedMessageId);

export const selectNewMessageDraft = createSelector(selectMessagesFeature, state => state.newMessageDraft);

export const selectIsNewMessageDisabled = createSelector(
  selectNewMessageDraft,
  newMessageDraft => newMessageDraft !== null
);

export const selectMessageById = (messageId: number) =>
  createSelector(selectMessages, entities => {
    const message = entities.find(f => f.messageId == messageId);
    return message === undefined ? null : message;
  });

export const selectSelectedMessage = createSelector(
  selectMessages,
  selectSelectedMessageId,
  (messages, selectedMessageId) => messages.find(message => message.messageId === selectedMessageId) || null
);
